import React from "react";
import moment from "moment";
import { TAnnex6V2Record } from "redux/app/annex6-v2/@types";
import { TAnnex6V2GroupF1 } from "redux/app/annex6-v2/groups/group-f";
import Annex6V2TableRows from "../Annex6V2TableRows";
import CommaSeparator from "components/_common/CommaSeparator";
import { marpolUtils } from "redux/app/marpol";

type OwnProps = {
	annex6V2Record: TAnnex6V2Record;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type Annex6V2GroupF1PreviewProps = OwnProps;

function Annex6V2GroupF1Preview(props: Annex6V2GroupF1PreviewProps) {
	const record = props.annex6V2Record as TAnnex6V2GroupF1;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	const metrics = "MT";

	function renderMain() {
		return (
			<Annex6V2TableRows
				record={record}
				tableRows={[
					[operationDate, "F", "1", renderItemP1()],
					[null, null, "2", renderItemP2()],
					[null, null, "3", renderItemP3()],
					[null, null, "4", renderItemP4()],
					[null, null, "5", renderItemP5()],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	function renderItemP1() {
		const { date: smtDate, time: smtTime } = record.itemF1P1;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);
		return (
			<h4 className="font-medium uppercase">
				Bunkering carried out at {utcTime.format("HH:mm")} hrs UTC on{" "}
				{utcTime.format("DD-MMM-YYYY")} ({smtTime} SMT on{" "}
				{moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}) from{" "}
				{record.itemF1P1.port}
			</h4>
		);
	}

	function renderItemP2() {
		const { fuelGrade, SulphurContent, quantity } = record.itemF1P2.fuelDetails;
		return (
			<h4 className="font-medium uppercase">
				Fuel of {fuelGrade} grade has sulphur content of {SulphurContent} %,
				Bunkered quantity is {quantity} {metrics}
			</h4>
		);
	}

	function renderItemP3() {
		if (!record.itemF1P3.tanks) return null;

		const totalQuantityInMT = record.itemF1P3.tanks
			.reduce(
				(result, currentTank) => result + currentTank.addedQuantityInMT,
				0
			)
			.toFixed(3);

		return (
			<h4 className="font-medium uppercase">
				{totalQuantityInMT} {metrics} bunkered to tanks. <br />
				<CommaSeparator
					items={record.itemF1P3.tanks.map((tank) => {
						return `${tank.addedQuantityInMT} ${metrics} ADDED TO ${tank.selectedTank.tankName} 
                        NOW CONTAINING ${tank.totalRetainedQuantityInMT} ${metrics}`;
					})}
					customSeperator={<br />}
				/>
			</h4>
		);
	}

	function renderItemP4() {
		const { bdn, bdnAttachmentLink } = record.itemF1P4;
		const attachmentId = record.isAutoCreated
			? record.attachmentSourceId
			: record.id;
		const attachmentRev = record.isAutoCreated
			? record.attachmentSourceRev
			: record._rev;

		return (
			<h4 className="font-medium uppercase">
				BDN REFERENCE NO: {bdn}
				{bdnAttachmentLink && (
					<>
						<br />
						<a
							href={marpolUtils.getAttachmentURL(
								bdnAttachmentLink,
								attachmentId,
								attachmentRev
							)}
							rel="noreferrer"
							target="_blank"
						>
							{bdnAttachmentLink}
						</a>
					</>
				)}
			</h4>
		);
	}

	function renderItemP5() {
		return (
			<h4 className="font-medium uppercase">
				<div>
					<p>Supplier: {record.itemF1P5.supplierDetails}</p>
					<p>
						Barge delivery details: {record.itemF1P5.bunkerDeliveryBargeDetails}
					</p>
				</div>
			</h4>
		);
	}

	return renderMain();
}

export default Annex6V2GroupF1Preview;
